import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={8} cy={8} r={0.75} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="m6.013 4.242.257-.136.098-.275.675-1.898c.033-.094.096-.124.128-.129a6.315 6.315 0 0 1 1.658 0c.032.005.095.035.128.129l.675 1.898.098.275.257.136c.093.05.184.102.272.157l.248.156.287-.053 1.98-.365c.099-.018.157.022.176.047.338.437.618.92.831 1.436.012.03.018.099-.047.175L12.426 7.33l-.19.222.011.291a4.296 4.296 0 0 1 0 .314l-.01.291.189.222 1.308 1.535c.065.076.06.146.047.175a6.242 6.242 0 0 1-.83 1.436c-.02.025-.078.065-.176.046l-1.98-.364-.288-.053-.248.156a4.26 4.26 0 0 1-.272.157l-.257.137-.098.274-.675 1.898c-.033.094-.096.124-.128.129a6.33 6.33 0 0 1-1.658 0c-.032-.005-.095-.035-.128-.129l-.675-1.898-.098-.274-.257-.137a4.21 4.21 0 0 1-.272-.157l-.248-.156-.287.053-1.98.365c-.099.018-.157-.021-.176-.047l-.589.454.589-.454a6.243 6.243 0 0 1-.831-1.436c-.012-.03-.018-.099.047-.175L3.574 8.67l.19-.222-.011-.291a4.338 4.338 0 0 1 0-.314l.01-.291-.189-.222-1.308-1.535c-.065-.076-.06-.146-.047-.175.213-.517.493-.999.83-1.436.02-.025.078-.065.176-.047l1.98.365.288.053.248-.156c.088-.055.179-.108.272-.157Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const StyledSvgGear = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgGear;
